export const START_TIMER = 4200;
export const START_LIVES = 2;

export const DOT_POINTS = 10;
export const ENERGIZER_POINTS = 50;
export const GHOST_POINTS = 200;

export const GHOST_IDLE_TIMER = 1200;
export const GHOST_SCARE_TIMER = 8000;

export const LOSE_LIFE_TIMER = 3000;

export const FRUIT_SPAWN = [70, 170];

export const BASE_SPEED = 14;
export const SPEED_INCREASE = 2;

export const DEBUG = false;
export const DEBUG_TIMESCALE = 1;
export const FPS = 30;
export const GODMODE = false;

export type ScareConfig = {
  time: number;
  numBlinks: number;
}

export enum Fruit {
  chili = 100,
  fries = 300,
  salad = 500,
  cherry = 700,
  apple = 1000,
  galaxian = 2000,
  bell = 3000,
  key = 5000
}

export const levels: Array<keyof typeof Fruit> = [
  'chili',
  'fries',
  'salad',
  'salad',
  'cherry',
  'cherry',
  'apple',
  'apple',
  'galaxian',
  'galaxian',
  'bell',
  'bell',
  'key',
];
